import { NewNames as NewNamesForm } from "@bgea-js/form-templates";
import donationHeaderWedInWord2 from "../../../../src/content/wednesday-in-the-word-2/donationHeader";
import * as React from 'react';
export default {
  NewNamesForm,
  donationHeaderWedInWord2,
  React
};